import { StoreUsersState } from '@/types';

export default {
  userList: (state: StoreUsersState) => state.userList,
};
